import {Box, SvgIcon} from "@mui/material";
import React from "react";

export default function BinocularIcon(props) {
  return(
      <img src="/Icons/binocular.svg" alt="binocular" {...props}/>
  )
}